/**
 * What a frame window shell tells the controls drawn inside its frame (the
 * resize handles): its test id prefix, the box it is drawn in, and how a
 * gesture shows and commits a new box.
 */
import { createContext, useContext } from "react";
import type { FocusWindowBox } from "@/lib/focus-window-layout";

export type FrameWindowTestIdPrefix =
  | "focus-window"
  | "floating-frame"
  | "desktop-pin";

export interface FrameWindowContextValue {
  testIdPrefix: FrameWindowTestIdPrefix;
  /** The box the window is drawn in right now. */
  box: FocusWindowBox;
  /** Draw the window in `box` while a gesture runs; `null` ends it. */
  showBox: (box: FocusWindowBox | null) => void;
  /** A resize ended in `box`. */
  commitResize: (box: FocusWindowBox) => void;
}

export const FrameWindowContext = createContext<FrameWindowContextValue | null>(
  null,
);

export function useFrameWindow(): FrameWindowContextValue | null {
  return useContext(FrameWindowContext);
}
